<template>
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-icon="InternetOutlined"
	>
		<path
			d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11ZM9.759 20.719c-.128-.445-.259-.963-.259-1.219 0-.5-1-1.5-1-1.5s-2-.5-2.5-1.5.5-2.5.5-2.5l-3.393-3.393A9.004 9.004 0 0 0 9.76 20.72ZM21 12a9.003 9.003 0 0 0-7.012-8.78c-.03 1.053-.133 2.925-.488 3.28-.5.5-3 1-3 1l-1 2-3 .5.5 2h5l4 1.5s.8.2.5 1c-.387.775-1.675 4.551-2.236 6.213A9.004 9.004 0 0 0 21 12Z"
			fill="currentColor"
		></path>
	</svg>
</template>
